/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import useFirebaseAuthStore from '@/stores/auth/firebase-auth';
import {User} from '@/api/auth';
import {actor} from '@/api/backend';
import {initStores, resetStores} from '@/stores';

/**
 * Starts observing changes of the state of the provided Firebase authentication service.
 *
 * <p>Must be called after Pinia is set up: `new Vue({ pinia: createPinia() })`.
 *
 * @param {FirebaseAuth} auth Firebase Authentication service
 */
export default function observeFirebaseAuth(auth) {
  const firebaseAuthStore = useFirebaseAuthStore();
  auth.subscribe({
    onSignIn(user: User) {
      actor.update(user.id);
      firebaseAuthStore.setUser(user);
      initStores();
    },
    /**
     * Forces a user to sign in immediately after sign-out.
     * Signed-out user cannot view contents of the web app.
     */
    onSignOut() {
      actor.clear();
      firebaseAuthStore.setUser(null);
      resetStores();
      auth.signIn();
    },
    onSignInFailed() {
      actor.clear();
      firebaseAuthStore.setSignInFailed();
      resetStores();
    },
  });
}
